export default "__VITE_ASSET__CQ$TtkAq__"